module.exports = __webpack_public_path__ + "assets/img/bg_服务点.888d394c.png";